import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// material-ui
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// project import
import Avatar from "components/@extended/Avatar";

// assets
import RightOutlined from "@ant-design/icons/RightOutlined";
import avatar1 from "assets/images/users/avatar-1.png";
import { cookies } from "utils/cookies";
import { useDispatch, useSelector } from "react-redux";
import { authAction } from "state/reducer/auth";
import { selectUser } from "state/reducer/user";

const ExpandMore = styled(IconButton, {
  shouldForwardProp: (prop) =>
    prop !== "theme" && prop !== "expand" && prop !== "drawerOpen",
})(({ theme, expand, drawerOpen }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(-90deg)",
  marginLeft: "auto",
  color: theme.palette.secondary.dark,
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  ...(!drawerOpen && {
    opacity: 0,
    width: 50,
    height: 50,
  }),
}));

// ==============================|| DRAWER - USER ||============================== //

export default function NavUser() {
  const navigate = useNavigate();

  const { isDashboardDrawerOpened, isComponentDrawerOpened } = useSelector(
    (state) => state.menu,
  );

  const drawerOpen = isDashboardDrawerOpened;
  const profile = useSelector(selectUser).getProfile;
  const dispatch = useDispatch();
  const loginInput = useSelector((state) => state.auth.login_input);

  async function clearStorage() {
    cookies.remove("token");
    cookies.remove("refreshToken");
    dispatch(
      authAction.setLoginInput({
        login_input: { ...loginInput, password: "" },
      }),
    );
    navigate("/login", { replace: true });
  }

  const handleLogout = async () => {
    Promise.allSettled([
      dispatch(
        authAction.logoutThunk({
          pathname: "/logout",
          queryParams: `?mode=${profile?.data?.settings[0]}&lang=${profile?.data?.settings[1]}`,
        }),
      ),
    ])
      .then(async () => {
        await clearStorage();
      })
      .catch(async (error) => {
        console.error(error);
        await clearStorage();
      });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        p: 1.25,
        px: !drawerOpen ? 1.25 : 3,
        borderTop: "2px solid",
        borderTopColor: "divider",
      }}
    >
      <List disablePadding>
        <ListItem
          disablePadding
          secondaryAction={
            <ExpandMore
              // theme={theme}
              expand={open}
              drawerOpen={drawerOpen}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              aria-label="show more"
            >
              <RightOutlined style={{ fontSize: "0.75rem" }} />
            </ExpandMore>
          }
          sx={{
            "& .MuiListItemSecondaryAction-root": {
              right: !drawerOpen ? -20 : -16,
            },
          }}
        >
          <ListItemAvatar>
            <Avatar
              alt="Avatar"
              src={avatar1}
              sx={{ ...(drawerOpen && { width: 46, height: 46 }) }}
            />
          </ListItemAvatar>
          <ListItemText
            primary={profile?.data?.employee_name || profile?.data?.fullname}
            secondary={profile?.data?.role?.name}
          />
        </ListItem>
      </List>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
        <MenuItem component={Link} to="/profile" onClick={handleClose}>
          Profile
        </MenuItem>
        <MenuItem component={Link} to="/account" onClick={handleClose}>
          My account
        </MenuItem>
      </Menu>
    </Box>
  );
}
